import { client } from './client'
import type {
  ChatCommandDescriptor,
  ChatCommandResult,
  ExecuteChatCommandRequest,
  TriggerWorkflowResponse,
  WorkflowDefinitionSummary,
} from '@/types'

export const chatCommandsApi = {
  getCommands: (projectId: string): Promise<ChatCommandDescriptor[]> =>
    client.get<ChatCommandDescriptor[]>(`/projects/${projectId}/chat-commands`).then((r) => r.data),

  execute: (projectId: string, req: ExecuteChatCommandRequest): Promise<ChatCommandResult> =>
    client.post<{ result: ChatCommandResult }>(`/projects/${projectId}/chat-commands/execute`, req).then((r) => r.data.result),

  getAvailableWorkflowsForChat: (projectId: string): Promise<WorkflowDefinitionSummary[]> =>
    client.get<WorkflowDefinitionSummary[]>(`/projects/${projectId}/workflows/available-for-chat`).then((r) => r.data),

  triggerWorkflowFromChat: (
    projectId: string,
    workflowName: string,
    payload: { chatId: string; inputValuesJson?: string },
  ): Promise<TriggerWorkflowResponse> =>
    client.post<TriggerWorkflowResponse>(`/projects/${projectId}/workflows/${workflowName}/trigger-from-chat`, {
      chatId: payload.chatId,
      inputValuesJson: payload.inputValuesJson,
    }).then((r) => r.data),
}
